var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAccess
    ? _c(
        "button",
        {
          staticClass: "btn btn-light btn-sm",
          attrs: { type: "button" },
          on: { click: _vm.onClick },
        },
        [_vm._v("\n    View options\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }